import { ref as c, toRefs as T, computed as d, watch as h, unref as f, provide as P, resolveComponent as v, openBlock as n, createElementBlock as O, Fragment as _, renderSlot as C, normalizeProps as x, guardReactiveProps as D, createTextVNode as w, createBlock as u, Teleport as E, createElementVNode as R, normalizeClass as S, withCtx as A, renderList as H, mergeProps as N, createCommentVNode as M, withModifiers as V } from "vue";
import z from "./design-system.es341.js";
/* empty css                    */
import F from "./design-system.es128.js";
import { useEventListener as L, unrefElement as j } from "./design-system.es125.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import q from "./design-system.es74.js";
import G from "./design-system.es75.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const J = {
  name: "DsDropdownDefault",
  components: {
    TouchOverlay: z,
    MenuItems: G,
    MenuItem: q
  },
  inheritAttrs: !1,
  props: {
    /**
     * Controls the open state of the dropdown.  This makes the dropdown controlled and will not work with uncontrolled options.
     */
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Reference to the trigger element.  This is used for advanced cases where the trigger ref may be used for more than just the trigger.
     */
    triggerRef: {
      type: Object,
      default: null
    },
    /**
     * Items to display in the dropdown.  This is an array of objects that will be passed to the MenuItem component.
     */
    items: {
      type: Array,
      default: null
    },
    /**
     * Function to map items object to MenuItem props for rendering.  This is useful when the items object does not match the MenuItem props.
     */
    mapItem: {
      type: Function,
      default: (t) => t
    }
  },
  emits: ["close"],
  setup(t, { emit: o }) {
    const e = c(!1), r = c(null), { isOpen: p, triggerRef: g } = T(t), i = c(null), m = d(() => t.isOpen === !0 || t.isOpen === !1);
    function a(s) {
      i.value = s;
    }
    h(g, a, { immediate: !0 }), h(p, (s) => {
      e.value = s;
    }, { immediate: !0 });
    function l() {
      m.value || (e.value = !e.value);
    }
    function y() {
      if (e.value) {
        if (m.value) {
          o("close");
          return;
        }
        e.value = !1;
      }
    }
    function b() {
      m.value || (e.value = !1);
    }
    const k = d(() => ({
      "aria-expanded": f(e),
      ref: f(i) ? void 0 : a
    })), I = d(() => ({
      ...k.value,
      isOpen: f(p),
      attrs: k.value
    }));
    function B(s) {
      r.value = j(s);
    }
    return L(i, "click", l), P("dsMenu", {
      bottomSheet: !0,
      isOpen: p,
      triggerProps: I,
      onItemClick: b,
      onBodyClick: y,
      onTriggerClick: l,
      registerSearchHeader: B
    }), {
      isOpenInternal: e,
      searchHeader: r,
      triggerProps: I,
      onBodyClick: y
    };
  }
};
function K(t, o, e, r, p, g) {
  const i = v("MenuItem"), m = v("MenuItems"), a = v("TouchOverlay");
  return n(), O(_, null, [
    C(t.$slots, "default", x(D(r.triggerProps)), void 0, !0),
    o[1] || (o[1] = w()),
    (n(), u(E, { to: "body" }, [
      R("div", {
        class: S(["ds-dropdown-bottom-sheet", {
          "ds-dropdown-bottom-sheet--open": r.isOpenInternal,
          "ds-dropdown-bottom-sheet--fill": r.searchHeader
        }])
      }, [
        C(t.$slots, "content", {}, () => [
          e.items ? (n(), u(m, { key: 0 }, {
            default: A(() => [
              (n(!0), O(_, null, H(e.items.map(e.mapItem), (l) => (n(), u(i, N({
                key: l.title,
                ref_for: !0
              }, l), null, 16))), 128))
            ]),
            _: 1
          })) : M("", !0)
        ], !0)
      ], 2),
      o[0] || (o[0] = w()),
      r.isOpenInternal ? (n(), u(a, {
        key: 0,
        onClick: V(r.onBodyClick, ["prevent", "stop"])
      }, null, 8, ["onClick"])) : M("", !0)
    ]))
  ], 64);
}
const Te = /* @__PURE__ */ F(J, [["render", K], ["__scopeId", "data-v-76c3c08b"]]);
export {
  Te as default
};
//# sourceMappingURL=design-system.es344.js.map
